"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const config = require("./config/reducers");
const workspaces = require("./workspaces/reducers");
const session = require("./session/reducers");
const me = require("./me/reducers");
const entities = require("./entities/reducers");
const extensions = require("./extensions/reducers");
exports.rootReducer = redux_1.combineReducers({
    entities: entities.default,
    config: config.default,
    workspaces: workspaces.default,
    session: session.default,
    me: me.default,
    extensions: extensions.default,
});
//# sourceMappingURL=reducers.js.map